export default __webpack_public_path__ + "static/media/naturesrevenge.4963df4d.png";